import React, { useState } from 'react';

import { Container } from './styles';

import { FaGithub, FaInstagram } from 'react-icons/fa';
import { BiWorld } from 'react-icons/bi';

import dimitri from '../../assets/dimitri.jpg';
import wendy from '../../assets/wendy.png';
import deil from '../../assets/deil.gif';

function Team() {

    const [users] = useState([{
        image: `${dimitri}`,
        nome: 'Dimitri#2445',
        cargo: 'Developer Owner',
        github: 'https://github.com/pequenojoohn',
    }, {
        image: `${wendy}`,
        nome: 'wendy#4238',
        cargo: 'Product Owner',
        instagram: 'https://www.instagram.com/sotrazz/'
    }, {
        image: `${deil}`,
        nome: 'DeiL#6458',
        cargo: 'Insfraestuture Manager',
        portfolio: 'https://discord.club/i/DeiL',
    }]);

    return (
        <Container>
            <figure>
                <h1>Team Soudy</h1>
            </figure>

            <section>
                {users.map(user => (
                    <div>
                        <img src={user.image} alt={user.nome} />
                        <h1>{user.nome}</h1>
                        <p>{user.cargo}</p>
                        <ul>
                            {user.github ?
                                <li>
                                    <a href={user.github} target="_blank" rel="noopener noreferrer"><FaGithub size={20} color={"#f12f65"} /></a>
                                </li>
                                :
                                ''
                            }
                            {user.portfolio ?
                                <li>
                                    <a href={user.portfolio} target="_blank" rel="noopener noreferrer"><BiWorld size={20} color={"#f12f65"} /></a>
                                </li>
                                :
                                ''
                            }
                            {user.instagram ?
                                <li>
                                    <a href={user.instagram} target="_blank" rel="noopener noreferrer"><FaInstagram size={20} color={"#f12f65"} /></a>
                                </li>
                                :
                                ''
                            }
                        </ul>
                    </div>
                ))}
            </section>
        </Container>
    );
}

export default Team;
